import React, { useState, useEffect } from "react";

const InputPINCode = ({
  name,
  value = "",
  onChange,
  placeholder,
  label,
  readOnly = false,
  required = false,
  setInputPINCodeError,
}) => {
  const [errMsg, setErrMsg] = useState("");

  const handleBlur = () => {
    const pinRegex = /^[1-9][0-9]{5}$/;
    if (required && value?.length === 0) {
      setErrMsg("Please enter a valid PIN code.");
      setInputPINCodeError((prevState) => ({
        ...prevState,
        pinCode: true,
      }));
    } else if (value?.length > 0 && !pinRegex.test(value)) {
      setErrMsg("PIN code must be exactly 6 digits and cannot start with 0.");
      setInputPINCodeError((prevState) => ({
        ...prevState,
        pinCode: true,
      }));
    } else {
      setErrMsg("");
      setInputPINCodeError((prevState) => ({
        ...prevState,
        pinCode: false,
      }));
    }
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const numericValue = inputValue.replace(/\D/g, "");
    onChange({ target: { name, value: numericValue } });

    if (errMsg) {
      setErrMsg("");
      setInputPINCodeError((prevState) => ({
        ...prevState,
        pinCode: false,
      }));
    }
  };

  useEffect(() => {
    if (!errMsg) {
      setInputPINCodeError((prevState) => ({
        ...prevState,
        pinCode: false,
      }));
    }
  }, [errMsg, setInputPINCodeError]);

  return (
    <div className="form-group">
      <label htmlFor={name} className="col-form-label">
        {label}
      </label>
      <input
        type="text"
        className="form-control"
        name={name}
        value={value}
        onChange={handleInputChange}
        onBlur={handleBlur}
        maxLength={6}
        placeholder={placeholder}
        required={required}
        readOnly={readOnly}
      />
      <small className="text-danger">{errMsg}</small>
    </div>
  );
};

export default InputPINCode;
